import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=21472457&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"
import style0 from "./edit.vue?vue&type=style&index=0&id=21472457&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21472457",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/.jenkins/workspace/crm-ui/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21472457')) {
      api.createRecord('21472457', component.options)
    } else {
      api.reload('21472457', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=21472457&scoped=true&", function () {
      api.rerender('21472457', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/crm/customer/customerAlter/edit.vue"
export default component.exports